// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"33":"bc7e3d9d","152":"60256ddf","245":"60256ddf","822":"bc7e3d9d","853":"bc7e3d9d","920":"3d56d7a9"}[chunkId] + ".chunk.css";
};